/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";
import moment from 'moment';
import { isMobile } from 'react-device-detect';

class VoteSch2023 extends PureComponent {
  state = {
    slideIndex: 1,
    slidePlay: true,
    voteList: [
      {
        part: '1차 예선',
        dateTitle: '11.27 - 11.29',
        title: '분기별 예선전',
        title1: '(분기별 작품 투표)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-11-27 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-11-27 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-11-29 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '2차 예선',
        dateTitle: '12.01 - 12.03',
        title: '후보별 2차 예선',
        title1: '(24개조, 1등 Pick 진행)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-01 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-01 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-03 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '32강',
        dateTitle: '12.05 - 12.07',
        title: '후보별 32강전',
        title1: '(4캐릭터 x 8개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-05 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-05 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-07 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '16강',
        dateTitle: '12.08 - 12.11',
        title: '후보별 16강전',
        title1: '(4캐릭터 x 4개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-08 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-08 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-11 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '8강',
        dateTitle: '12.12 - 12.14',
        title: '후보별 8강전',
        title1: '(2캐릭터 x 4개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-12 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-12 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-14 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '4강',
        dateTitle: '12.15 - 12.20',
        title: '후보별 4강전',
        title1: '(2캐릭터 x 2개조)',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-15 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-15 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-20 16:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '3, 4위전',
        dateTitle: '12.21 - 12.26',
        title: '준결승전',
        title1: '후보별 준결승전',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-21 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-21 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-26 18:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {
        part: '결승전',
        dateTitle: '12.21 - 12.26',
        title: '결승전',
        title1: '후보별 결승전',
        button:
          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
          '2023-12-21 16:00:00'
            ? '투표예정'
            : moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                '2023-12-21 16:00:00' &&
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                '2023-12-26 18:00:00'
            ? '투표하기'
            : '결과보기',
      },
      {},
    ],
    slide: isMobile ? 189 * -6 : 250 * -4,
  };
  componentDidMount = () => {
    console.log('did mount');
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.i !== nextProps.childProps.i;
    //return false;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.childProps.i, nextProps.childProps.i)
    if (this.props.childProps.i !== nextProps.childProps.i) {
    } else {
    }
  };

  _onNext = () => {
    //this.slider.slickNext()
    //console.log('next')
    const { slide, slideIndex } = this.state;
    if (slideIndex >= 5) {
    } else {
      this.setState({
        slide: isMobile ? slide - 189 : slide - 250,
        slideIndex: slideIndex + 1,
      });
    }

    console.log(slide, slideIndex);
  };
  _onPrev = () => {
    //this.slider.slickPrev()
    const { slide, slideIndex } = this.state;
    console.log('prev');
    console.log(slideIndex);

    if (slideIndex < 0) {
    } else {
      this.setState({
        slide: isMobile ? slide + 189 : slide + 250,
        slideIndex: slideIndex - 1,
      });
    }

    console.log(slide, slideIndex);
  };
  _move = (part) => {
    console.log(part);

    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // const today ='2022-12-07 00:00:00'

    if (part === '1차 예선') {
      if (today >= '2023-11-27 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=128&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('1차 예선은 11월 27일 오후 4시에 시작됩니다.');
      }
    } else if (part === '2차 예선') {
      if (today >= '2023-12-01 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=129&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('2차 예선은 12월 01일 오후 4시에 시작됩니다.');
      }
    } else if (part === '32강') {
      if (today >= '2023-12-05 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=130&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('32강은 12월 05일 오후 4시에 시작됩니다.');
      }
    } else if (part === '16강') {
      if (today >= '2023-12-08 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=131&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('16강은 12월 08일 오후 4시에 시작됩니다.');
      }
    } else if (part === '8강') {
      if (today >= '2023-12-12 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=132&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('8강은 12월 12일 오후 4시에 시작됩니다.');
      }
    } else if (part === '4강') {
      if (today >= '2023-12-15 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=133&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('4강은 12월 15일 오후 4시에 시작됩니다.');
      }
    } else if (part === '3, 4위전') {
      if (today >= '2023-12-21 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=134&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('3, 4위전은 12월 21일 오후 4시에 시작됩니다.');
      }
    } else if (part === '결승전') {
      if (today >= '2023-12-21 16:00:00') {
        window.open(
          'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=134&event_id=11',
          'aketo',
          ''
        );
      } else {
        alert('결승전은 12월 21일 오후 4시에 시작됩니다.');
      }
    }
  };

  _renderItem = () => {
    const { voteList, slide } = this.state;

    const list = voteList.map((item, index) => {
      return (
        <div
          key={index}
          className={
            item.button === '투표하기'
              ? 'on'
              : item.button === '결과보기'
              ? 'off'
              : 'off'
          }
          style={{
            transform: `translateX(${slide}px)`,
            transition: '0.5s ease',
          }}
        >
          <div className="tit">{item.part}</div>
          <div className="date">{item.dateTitle}</div>
          <div className="info">
            {item.title}
            <br />
            {item.title1}
          </div>
          <button type="button" onClick={() => this._move(item.part)}>
            {item.button}
          </button>
        </div>
      );
    });

    return list;
  };
  render() {
    const { voteList } = this.state;
    //console.log(slide, slideIndex)
    return (
      <div className="schdule_wrap">
        <div className="schdule_inner">
          <div className="schdule">{voteList ? this._renderItem() : null}</div>
        </div>

        <a
          style={{ cursor: 'pointer' }}
          className="arrw prev"
          onClick={this._onPrev}
        >
          이전
        </a>
        <a
          style={{ cursor: 'pointer' }}
          className="arrw next"
          onClick={this._onNext}
        >
          다음
        </a>
      </div>
    );
  }
}

export default shopContext(withRouter(VoteSch2023));
